import React from 'react';
import clsx from 'clsx';

import { useAutosizeTextarea } from 'hooks/useAutosizeTextarea';
import './comment-editor.scss';

const CommentEditor = ({ name, value, onChange, actions, textareaProps = {} }) => {
  const { textareaRef } = useAutosizeTextarea();
  return (
    <div className="comment-editor">
      <textarea
        {...textareaProps}
        ref={textareaRef}
        name={name}
        value={value}
        className="comment-textarea"
        onChange={(e) => onChange(e)}
      />
      <div className="comment-editor__actions">
        {actions.map((action, index) => {
          return (
            <button
              onClick={action.onClick}
              className={clsx('button', 'comment-add-button', action.className && action.className)}
              key={`action${index}`}
            >
              {action.title}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CommentEditor;
